const API_URL = 'https://pickleball-api.clarityva-support.workers.dev/api';

export const api = {
  // Auth
  login: async (username: string, password: string) => {
    const response = await fetch(`${API_URL}/auth/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ username, password }),
    });
    return response.json();
  },

  changePassword: async (username: string, oldPassword: string, newPassword: string) => {
    const response = await fetch(`${API_URL}/auth/change-password`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ username, oldPassword, newPassword }),
    });
    return response.json();
  },

  // Bookings
  getBookings: async (date?: string) => {
    const url = date ? `${API_URL}/bookings?date=${date}` : `${API_URL}/bookings`;
    const response = await fetch(url);
    return response.json();
  },

  createBooking: async (booking: any) => {
    const response = await fetch(`${API_URL}/bookings`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(booking),
    });
    return response.json();
  },

  updateBookingStatus: async (id: number, status: string) => {
    const response = await fetch(`${API_URL}/bookings/${id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ status }),
    });
    return response.json();
  },

  deleteBooking: async (id: number) => {
    const response = await fetch(`${API_URL}/bookings/${id}`, {
      method: 'DELETE',
    });
    return response.json();
  },
  // Add to the api object
getSettings: async () => {
  const response = await fetch(`${API_URL}/settings`);
  return response.json();
},

updateSettings: async (settings: any) => {
  const response = await fetch(`${API_URL}/settings`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(settings),
  });
  return response.json();
},

getCourts: async () => {
  const response = await fetch(`${API_URL}/courts`);
  return response.json();
},

addCourt: async (name: string) => {
  const response = await fetch(`${API_URL}/courts`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ name }),
  });
  return response.json();
},

deleteCourt: async (id: number) => {
  const response = await fetch(`${API_URL}/courts/${id}`, {
    method: 'DELETE',
  });
  return response.json();
},
updateBookingNotes: async (id: number, admin_notes: string) => {
  const response = await fetch(`${API_URL}/bookings/${id}/notes`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ admin_notes }),
  });
  return response.json();
},
};
